<mat-form-field
    *ngIf="asFormsControl().currency"
    class="app-input prefix"
    [floatLabel]="asFormsControl().floatingLabelNever && 'never'"
>
    <input
        matInput
        [placeholder]="currencyPlaceholder"
        [readonly]="true"
        [value]="asFormsControl().currency"
    >
</mat-form-field>
<mat-form-field
    class="app-input"
    [ngClass]="{'fill': asFormsControl().isPercentage || asFormsControl().currency}"
    [floatLabel]="asFormsControl().floatingLabelNever && 'never'"
>
    <input
        matInput
        #input
        [placeholder]="asFormsControl().placeholder"
        [disabled]="asFormsControl().disabled"
        [readonly]="asFormsControl().readonly"
        (focus)="onTouched && onTouched()"
        (blur)="convertToFloat($event)"
        (click)="moveCaretToEnd($event)"
        (keypress)="onKeyPress($event)"
        (paste)="onPaste($event)"
    >
</mat-form-field>
<mat-form-field
    *ngIf="asFormsControl().isPercentage"
    class="app-input suffix"
    [floatLabel]="'never'"
>
    <input
        matInput
        [placeholder]="percentagePlaceholder"
        [readonly]="true"
        [value]="'%'"
    >
</mat-form-field>
<div
    *ngIf='asFormsControl().errors.length > 0'
    class="form-text text-danger"
>
    <span *ngFor="let error of asFormsControl().errors">{{error}}</span>
</div>